"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanHtml = void 0;
var cleanHtml = function cleanHtml(htmlString) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(htmlString, 'text/html');
  var cleanText = doc.body.textContent;
  return cleanText || '';
};
exports.cleanHtml = cleanHtml;